import { useTranslation } from 'react-i18next';

import { OrderEquipDetail } from 'model/Order';
import { drawLockingInfo, isLockedByLockingInfo } from 'util/commonUtil';

type EquipRowProps = {
  orderEquip: OrderEquipDetail | null;
};

export default function EquipRow({ orderEquip }: EquipRowProps) {
  const { t } = useTranslation();

  if (!orderEquip) {
    return (
      <>
        <td>{''}</td>
        {/* <td>{''}</td> */}
        <td>{''}</td>
        <td>{''}</td>
        <td>{''}</td>
        <td>{''}</td>
        <td>{''}</td>
        <td>{''}</td>
        {/* <td>{''}</td>
        <td>{''}</td> */}
      </>
    );
  }
  return (
    <>
      <td>{`${orderEquip.equipName} (${orderEquip.equipCode})`}</td>
      {/* <td>{convertLotoTypeToString(orderEquip.lotoType)}</td> */}
      <td className={orderEquip.prodCnt > 0 ? 'check' : ''} aria-label={'td'}>
        <div
          className={
            orderEquip.prodCnt > 0
              ? `bg-red ${isLockedByLockingInfo(orderEquip.prodLock)}`
              : ''
          }
        />
      </td>
      <td className={orderEquip.elecCnt > 0 ? 'check' : ''} aria-label={'td'}>
        <div
          className={
            orderEquip.elecCnt > 0
              ? `bg-green ${isLockedByLockingInfo(orderEquip.elecLock)}`
              : ''
          }
        />
      </td>
      <td className={orderEquip.mechCnt > 0 ? 'check' : ''} aria-label={'td'}>
        <div
          className={
            orderEquip.mechCnt > 0
              ? `bg-yellow ${isLockedByLockingInfo(orderEquip.mechLock)}`
              : ''
          }
        />
      </td>
      {/* <td className={orderEquip.etcCnt > 0 ? 'bg-purple' : ''}>
        {orderEquip.etcCnt}
        {orderEquip.etcCnt > 0 && (
          <div className={'nowrap'}>
            <hr />
            {`${
              orderEquip.etcLocks?.filter((lock) => lock.unlockRegDate !== null)
                .length ?? 0
            } / ${
              orderEquip.etcLocks?.filter((lock) => lock.lockRegDate !== null)
                .length ?? 0
            }`}
          </div>
        )}
      </td> */}
      <td className={'pl'}>
        <div className={'pl-etc'}>
          {orderEquip.prodLock && (
            <div>{drawLockingInfo(orderEquip.prodLock)}</div>
          )}
        </div>
      </td>
      <td className={'pl'}>
        <div className={'pl-etc'}>
          {orderEquip.elecLock && (
            <div>{drawLockingInfo(orderEquip.elecLock)}</div>
          )}
        </div>
      </td>
      <td className={'pl'}>
        <div className={'pl-etc'}>
          {orderEquip.mechLock && (
            <div>{drawLockingInfo(orderEquip.mechLock)}</div>
          )}
        </div>
      </td>
      {/* <td>
        <div className={'pl-etc'}>
          {orderEquip.etcLocks && (
            <>
              <div>{drawLockingInfo(orderEquip.etcLocks[0])}</div>
              {orderEquip.etcLocks.length > 1 && (
                <p className={'ml-10'}>{`${t('conclusion.other')} ${
                  orderEquip.etcLocks.length - 1
                }`}</p>
              )}
            </>
          )}
        </div>
      </td> */}
    </>
  );
}
